"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapDependencies = void 0;
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var mapDependencies = exports.mapDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createMap: _factoriesAny.createMap
};